const FutureExpectationsLayout = ({ data }: any) => {
    const {
        hcp = [],
        patients = [],
        caregivers = [],
        three_to_five_year_predictions = [],
    } = data;

    return (
        <div className="w-full flex flex-col gap-6 mt-4">

            {/** ------------------------------
             *  TOP SECTION (2 columns)
             * -------------------------------- */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 w-full">

                {/** LEFT LARGE BOX - like screenshot */}
                <div className="bg-[#F5FBEF] border-4 border-[#4A731F] rounded-2xl p-3">
                    <h2 className="text-xl font-bold mb-4 text-[#2E4A1C]">
                        Implications for the Next 3–5 Years
                    </h2>

                    <ul className="space-y-2 text-[#2E2E2E]">
                        {three_to_five_year_predictions.map((item: string, idx: number) => (
                            <li key={idx} className="flex items-start">
                                <span className="mr-2">•</span>
                                {item}
                            </li>
                        ))}
                    </ul>
                </div>

                {/** RIGHT SECTION — 3 pill cards */}
                <div className="flex flex-col gap-2 w-full">

                    {/** For Patients */}
                    <div className="bg-[#E7F8D8] border-2 border-[#4A731F] rounded-2xl p-2">
                        <span className="font-bold text-[#2E4A1C]">For Patients: </span>
                        <span className="text-[#1B1B1B]">
                            {patients.join(" ")}
                        </span>
                    </div>

                    {/** For Caregivers */}
                    <div className="bg-[#B6DE89] border-2 border-[#4A731F] rounded-2xl p-2">
                        <span className="font-bold text-[#2E4A1C]">For Caregivers: </span>
                        <span className="text-[#1B1B1B]">
                            {caregivers.join(" ")}
                        </span>
                    </div>

                    {/** For HCPs */}
                    <div className="bg-[#E3F6D4] border-2 border-[#4A731F] rounded-2xl p-2">
                        <span className="font-bold text-[#2E4A1C]">For HCPs: </span>
                        <span className="text-[#1B1B1B]">
                            {hcp.join(" ")}
                        </span>
                    </div>

                </div>
            </div>

            {/** ------------------------------
             *  BOTTOM FULL-WIDTH BOX
             * -------------------------------- */}
            <div className="bg-[#F5FBEF] border-4 border-[#4A731F] rounded-2xl p-3 w-full">
                <h2 className="text-xl font-bold text-center mb-4 text-[#2E4A1C]">
                    What Participants Expect
                </h2>

                <ul className="space-y-2 text-[#2B2B2B]">
                    {three_to_five_year_predictions.map((item: string, index: number) => (
                        <li key={index} className="flex items-start">
                            <span className="mr-2">•</span>
                            {item}
                        </li>
                    ))}
                </ul>
            </div>

        </div>
    );
};

export default FutureExpectationsLayout;
